import React from "react";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-info">
        <h1>Glenn Bergendahl</h1>
        <p>The Weblogistian</p>
      </div>
      <div className="footer-contact">
        <h3>Contact me</h3>
        <p>info@glennbergendahl.com</p>
        <p>+47 93963482</p>
      </div>
      <div className="footer-sns">
        <div className="design-by">Design By Glenn Bergendahl</div>
        <div className="sns-links">
          <a href="https://linkedin.com" target="_blank" rel="noreferrer">
            <i className="fab fa-linkedin linkedin"></i>
          </a>
          <a href="https://twitter.com" target="_blank" rel="noreferrer">
            <i className="fab fa-twitter twitter"></i>
          </a>
          <a href="https://facebook.com" target="_blank" rel="noreferrer">
            <i className="fab fa-facebook facebook"></i>
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
